<template>
  <div class="container py-5 privacy-policy">
    <h1 class="mb-3 display-5 fw-bold text-primary animate__animated animate__fadeInDown">
      <i class="fas fa-shield-alt me-2"></i> Politica de Confidențialitate
    </h1>
    <p class="text-muted animate__animated animate__fadeIn animate__delay-1s">
      Ultima actualizare: Iunie 2025
    </p>

    <div class="mt-5">
      <div class="policy-item mb-5 animate__animated animate__fadeInUp">
        <h4><i class="fas fa-user me-2 text-primary"></i> 1. Informații colectate</h4>
        <p>
          Colectăm date precum nume, email și mesajele trimise prin formularul de cerere. Acestea sunt utilizate doar pentru a răspunde solicitărilor și a furniza servicii de consultanță.
        </p>
      </div>

      <div class="policy-item mb-5 animate__animated animate__fadeInUp animate__delay-1s">
        <h4><i class="fas fa-lock me-2 text-primary"></i> 2. Securitate</h4>
        <p>
          Luăm măsuri tehnice pentru a proteja datele utilizatorilor. Totuși, nicio transmisie online nu este 100% sigură.
        </p>
      </div>

      <div class="policy-item mb-5 animate__animated animate__fadeInUp animate__delay-2s">
        <h4><i class="fas fa-cookie-bite me-2 text-primary"></i> 3. Cookie-uri</h4>
        <p>
          Folosim cookie-uri pentru a îmbunătăți experiența de navigare. Puteți refuza cookie-urile din setările browserului.
        </p>
      </div>

      <div class="policy-item mb-5 animate__animated animate__fadeInUp animate__delay-3s">
        <h4><i class="fas fa-user-shield me-2 text-primary"></i> 4. Drepturile utilizatorilor</h4>
        <p>
          Aveți dreptul de a accesa, rectifica sau șterge datele personale. Ne puteți contacta la <strong>emailul oficial</strong> pentru orice solicitare.
        </p>
      </div>

      <div class="policy-item animate__animated animate__fadeInUp animate__delay-4s">
        <h4><i class="fas fa-users-slash me-2 text-primary"></i> 5. Terți</h4>
        <p>
          Nu partajăm datele dvs. cu terți, cu excepția cazurilor prevăzute de lege.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.privacy-policy {
  line-height: 1.8;
  color: #333;
}
.policy-item h4 {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.policy-item p {
  margin-left: 2.2rem;
  color: #555;
}
</style>
